import * as Yup from 'yup';
import axios from 'axios';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useFormik, Form, FormikProvider } from 'formik';
import { Icon } from '@iconify/react';
import eyeFill from '@iconify/icons-eva/eye-fill';
import eyeOffFill from '@iconify/icons-eva/eye-off-fill';
import { Stack, TextField, IconButton, InputAdornment, Alert } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { adminLogin } from '../../../config/services/users'
import { EncryptData } from '../../../utils/encryptDecrypt';
import settings from '../../../config/settings';
import { userActivityLog } from '../../../config/services/activityLog';
// ----------------------------------------------------------------------

export default function LoginForm() {
    const navigate = useNavigate();
    const [showPassword, setShowPassword] = useState(false);
    const [authError, setAuthError] = useState(null);


    const LoginSchema = Yup.object().shape({
        username: Yup.string().required('Username is required'),
        password: Yup.string().required('Password is required')
    });

    useEffect(() => localStorage.clear(), []);

    const formik = useFormik({
        initialValues: { username: '', password: '' },
        validationSchema: LoginSchema,
        onSubmit: (values, actions) => {
            let { username, password } = values

            adminLogin({ username, password })
                .then(resp => {
                    if (resp?.data?.statusCode === 0) {
                        let { errorMessage } = resp?.data?.error
                        setAuthError(errorMessage)
                        actions.setSubmitting(false)
                    }
                    else if (resp?.token) {
                        let { token,cubeToken, menusAllowed, userData,role } = resp
                                   
                        actions.setSubmitting(false)
                        let trackingEvent = {
                            em_guid: userData.s_uuid,
                            uuid: userData.s_uuid,
                            landing_page: '/dashboard',
                            action: "adminLogin",
                            date_time: new Date().toISOString(),
                            platform: "Report-Engine",
                            envirnment: settings?.env ,
                            app_version: settings?.version,
                            browser: navigator?.userAgent, 
                            os_details: navigator?.platform,
                            event_type: "Login",
                            eventStep: "adminLogin",
                            click_type: "Login",
                            value: JSON.stringify(userData),
                        }                        
                        localStorage.setItem('accessToken', token)
                        if(cubeToken){
                            localStorage.setItem('cubeToken', cubeToken)
                        }
                        localStorage.setItem('loginSource', EncryptData('adminLogin'))
                        localStorage.setItem('userTypeId', EncryptData(resp?.userType?._id))
                        localStorage.setItem('userType', EncryptData(JSON.stringify(resp?.userType)))
                        axios.defaults.headers.common['accessToken'] = token;
                        userActivityLog(trackingEvent)
                        if (userData.s_uuid) {
                            let encryptedId = EncryptData(userData.s_uuid)
                            let encryptedArrayId = EncryptData(userData.s_uuid)

                            localStorage.setItem('username', encryptedId)
                            localStorage.setItem('uuid', encryptedId)
                            localStorage.setItem('s_uuid', encryptedId)
                            localStorage.setItem('t_uuid', encryptedArrayId)
                            localStorage.setItem('s_uuids', encryptedArrayId)
                        }
                        //console.log(userData)
                        if (userData?.schoolCodes?.length) {
                            let encryptedArraySchoolCode = EncryptData(JSON.stringify(userData?.schoolCodes))
                            localStorage.setItem('school_code', encryptedArraySchoolCode)
                        }

                        if (role) {
                            localStorage.setItem('role', EncryptData(role))
                        }

                        let redirectTo = '/dashboard'

                        if (menusAllowed?.length > 0) {
                            redirectTo = "/" + menusAllowed?.[0]?.menuId
                            localStorage.setItem('menusAllowed', EncryptData(JSON.stringify(menusAllowed)))
                            //redirectTo = '/dashboard'
                        }else {
                            localStorage.removeItem('menusAllowed')
                        }
                        const beforeLoginUrl = sessionStorage.getItem('beforeLogin');
                        sessionStorage.removeItem('beforeLogin');
                        navigate(beforeLoginUrl ?? redirectTo)
                    }
                    else {
                        console.log(resp)
                        actions.setSubmitting(false)
                        console.error(resp)
                    }
                }).catch(
                    err => {
                        console.log(err)
                        actions.setSubmitting(false)
                    }
                )
        }
    });

    const { errors, touched, isSubmitting, handleSubmit, getFieldProps } = formik;

    const handleShowPassword = () => {
        setShowPassword((show) => !show);
    };

    return (
        <FormikProvider value={formik}>
            <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
                <Stack spacing={3}>
                    <TextField
                        fullWidth
                        autoComplete="username"
                        type="text"
                        label="Username (Email Or Employee Code)"
                        {...getFieldProps('username')}
                        error={Boolean(touched.username && errors.username)}
                        helperText={touched.username && errors.username}
                    />
                    <TextField
                        fullWidth
                        autoComplete="current-password"
                        type={showPassword ? 'text' : 'password'}
                        label="Password"
                        {...getFieldProps('password')}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton onClick={handleShowPassword} edge="end">
                                        <Icon icon={showPassword ? eyeFill : eyeOffFill} />
                                    </IconButton>
                                </InputAdornment>
                            )
                        }}
                        error={Boolean(touched.password && errors.password)}
                        helperText={touched.password && errors.password}
                    />
                </Stack>

                {authError ? <Stack mt={3}>
                    <Alert severity="error">{authError}</Alert>
                </Stack> : null}

                <Stack alignItems="center" justifyContent="space-between" sx={{ my: 2 }}>
                    <LoadingButton mt={2} fullWidth size="large" type="submit" variant="contained" loading={isSubmitting}> Login</LoadingButton>
                </Stack>
            </Form>
        </FormikProvider>
    );
}
